import { IconPropsType } from './types/IconsProps.type';

type DownloadIconProps = IconPropsType;

export const DownloadIcon = ({
  width = 20,
  height = 20,
  className = '',
  style = {},
  fillColor = 'currentColor',
}: DownloadIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        fill: 'none',
        stroke: fillColor,
        strokeWidth: 1.9,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        ...style,
      }}
    >
      <path d="M12 16V5" />
      <path d="M8 9l4-4 4 4" />
      <path d="M4 16v3h16v-3" />
    </svg>
  );
};